import styled, { css } from 'styled-components'
import { Flex, Box } from 'rebass'
import { style,color, height, zIndex, top, left, fontWeight, position, border, order } from 'styled-system'

const requiredColor = style({
  prop: 'requiredColor',
  cssProperty: 'color',
  key: 'colors'
})

const rightPosition = style({
  prop: 'rightPosition',
  cssProperty: 'right',
  key: 'position'
})

const topPosition = style({
  prop: 'topPosition',
  cssProperty: 'top',
  key: 'position'
})

const LabelBox = props => {
  return (
    <Box
      {...props}
      css={[
        `
          position: relative;
          display: block;
        `,
        color,
        top,
        left,
        height,
        zIndex,
        order,
        props =>
          props.required
            ? css`
                :after {
                    content: "*";
                    position: absolute;
                    font-size: 12px;
                    ${topPosition}
                    ${rightPosition}
                    ${requiredColor}
                }
            `
            : '',
        position
      ]}>
      {props.children}
    </Box>
  )
}

LabelBox.defaultProps = {
  as: 'label',
  requiredColor: 'rgba(235, 81, 96, 0.8)',
  rightPosition: '4px',
  topPosition: '20px'
}

export default LabelBox
